import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { GetAllProfessionalsUseCaseInterface } from 'domain/usecases';
// import { IProfessionalsListsFilters } from 'presentation/app/modules/Professionals/models/professionals-lists-filters';

interface IProfessionalsListState {
  professionalsData: GetAllProfessionalsUseCaseInterface.Result;
  // professionalsFilters: IProfessionalsListsFilters;
}

// interface IPayloadProfessionalsListFilters
//   extends PayloadAction<IProfessionalsListsFilters> {}

interface IPayloadProfessionalsData
  extends PayloadAction<GetAllProfessionalsUseCaseInterface.Result> {}

const initialState: IProfessionalsListState = {
  professionalsData: null,
  // professionalsFilters: null,
};

export const ProfessionalsListsSlice = createSlice({
  name: 'professionals-lists',
  initialState,
  reducers: {
    loadProfessionalsData: (state, action: IPayloadProfessionalsData) => {
      state.professionalsData = action.payload;
    },
    clearProfessionalsData: (state) => {
      state.professionalsData = null;
    },
    // loadProfessionalsFilters: (state, action: IPayloadProfessionalsListFilters) => {
    //   state.professionalsFilters = action.payload;
    // },
    // clearProfessionalsFilters: (state) => {
    //   state.professionalsFilters = null;
    // },
  },
});

export const {
  loadProfessionalsData,
  clearProfessionalsData,
  // loadProfessionalsFilters,
  // clearProfessionalsFilters,
} = ProfessionalsListsSlice.actions;

export default ProfessionalsListsSlice.reducer;
